// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RedEnvelopeTwoToneSvg from "@ant-design/icons-svg/es/asn/RedEnvelopeTwoTone";
import AntdIcon from '../components/AntdIcon';

var RedEnvelopeTwoTone = function RedEnvelopeTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: RedEnvelopeTwoToneSvg
  }));
};

RedEnvelopeTwoTone.displayName = 'RedEnvelopeTwoTone';
export default React.forwardRef(RedEnvelopeTwoTone);